import PropTypes from 'prop-types';

import { calculatePercentageChange } from './utils';
import { graphCurrencyFormatter } from '../../graphs/utils';
import { AnalyticsMetric } from './AnalyticsMetric';

export function AnalyticsMetricCurrency({ title, tooltip, value, currency, prevValue, loading, roundValue = false }) {
  const percentageChange = calculatePercentageChange(value, prevValue);

  const displayedValue = roundValue ? Math.round(Number(value / 100)) : Number(value / 100);
  const displayedPrevValue = roundValue ? Math.round(Number(prevValue / 100)) : Number(prevValue / 100);

  return (
    <AnalyticsMetric
      title={title}
      tooltip={tooltip}
      value={graphCurrencyFormatter(displayedValue, currency)}
      prevValue={prevValue ? graphCurrencyFormatter(displayedPrevValue, currency) : undefined}
      percentageChange={percentageChange}
      loading={loading}
    />
  );
}

AnalyticsMetricCurrency.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currency: PropTypes.string.isRequired,
  prevValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loading: PropTypes.bool,
};
